module.exports = __webpack_public_path__ + "img/9788990364982.86f35e05.jpg";